import DynamicIcon from '@/components/atoms/DynamicIcon/index';
import {
  RideIconButton,
  RideGlArrowBack,
  RideTextField,
  RideGlSearchSolid
} from '@rimac-seguros/ride-system-components';
import React, { useRef, useState } from 'react';

export const SearchModal = ({
  iconResult,
  options,
  isFocus,
  setIsFocus,
  onSelect,
  placeholder
}) => {
  const [searchText, setSearchText] = useState('');

  const ref = useRef(null);

  const filteredList = searchText
    ? options &&
      options.filter((item) =>
        item.label.toLowerCase().includes(searchText.toLowerCase())
      )
    : [];

  const highlightText = (text, highlight) => {
    if (!highlight) return text;
  
    const escapeRegExp = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  
    const escapedHighlight = escapeRegExp(highlight);
    const regex = new RegExp(`(${escapedHighlight})`, 'gi');
    const parts = text.split(regex);
  
    return parts.map((part, index) =>
      part.match(regex) ? (
        <strong key={index} style={{ whiteSpace: 'pre-wrap' }}>
          {part}
        </strong>
      ) : (
        <>{part}</>
      )
    );
  };

  return (
    <div className={`modal-search`}>
      <div className={`${!isFocus && 'no-focus'} w-full relative`}>
        {isFocus && (
          <RideIconButton
            glyph={<RideGlArrowBack />}
            variant="unfill"
            size="large"
            className="iconButton mr-4"
            onClick={() => {
              setIsFocus(false);
              setSearchText('');
              if (ref.current) {
                ref.current.value = '';
              }
            }}
          />
        )}
        <RideTextField
          ref={ref}
          placeholder={placeholder}
          onFocus={() => setIsFocus(true)}
          onChange={(e) => setSearchText(e.target.value)}
          size="large"
          className="w-full"
          glyph={<RideGlSearchSolid />}
          glyphPosition="right"
        />
      </div>
      {filteredList.length > 0 && (
        <div className="modal-search_result pb-ride-gl-spacing-10xlarge">
          {isFocus &&
            filteredList.map((item, index) => (
              <div
                key={index}
                onClick={(e) => {
                  onSelect(item.value);
                }}
              >
                {iconResult !== '' && (
                  <DynamicIcon icon={iconResult} size={'2x-large'} />
                )}

                <p>{highlightText(item.label, searchText)}</p>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
